import { render, staticRenderFns } from "./LiteratureTrait.vue?vue&type=template&id=dbb73d4e&"
import script from "./LiteratureTrait.vue?vue&type=script&lang=js&"
export * from "./LiteratureTrait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports